import React from "react";
import { Pie } from "react-chartjs-2";

import { Link, useNavigate } from "react-router-dom";
import MainCardFour from "../Cards/MainCardFour";
import MainCardOne from "../Cards/MainCardOne";

export const CardCompfive = () => {

  return (
    <div>
      <div className="border p-2 pb-3 px-3 mt-3" style={{ background: '#b9c9bd' }}>
        <div className="col-12 col-md-7 col-lg-8 mb-xl-0 align-self-center align-items-center">
          <h6 className="fw-bold px-1 text-dark pt-1">
            Nursery level
          </h6>
        </div>
        <div className="row mr-1 mr-lg-0 px-0">
          <div className="col-12 col-lg-3">
          <div className="card pb-4 pt-3 a_card n_shadow">
            <div className="row px-2">
              <div className="col-12 col-lg-8">
                <h2 className='text-dark ps-4 pt-2'>346</h2>
              </div>
              <div className="col-12 col-lg-4">
                <img src="./static/assets/img/dashboard/beneficiary.png" alt="" className = "Images ms-3 ms-lg-0" />
              </div>
              <div className="col-12 pt-4 px-3">
                <p className="green" style={{ fontWeight: "600", marginBottom: "-7px" }}>Total number of beneficiaries</p>
              </div>
            </div>
          </div>
          </div>

          <div className="col-12 col-lg-3 mt-2 mt-lg-0">
          <div className="card pb-4 pt-3 a_card n_shadow">
            <div className="row px-2">
              <div className="col-12 col-lg-8">
                <h2 className='text-dark ps-4 pt-2'>346</h2>
              </div>
              <div className="col-12 col-lg-4">
                <img src="./static/assets/img/dashboard/rubberplantations.png" alt="" className = "Images ms-3 ms-lg-0" />
              </div>
              <div className="col-12 pt-4 px-3">
                <p className="green" style={{ fontWeight: "600", marginBottom: "-7px" }}>Total number of rubber plantations</p>
              </div>
            </div>
          </div>
          </div>

          <div className="col-12 col-lg-3 mt-2 mt-lg-0 ">
          <div className="card pb-4 pt-3 a_card n_shadow">
            <div className="row px-2">
              <div className="col-12 col-lg-8">
                <h2 className='text-dark ps-4 pt-2'>346</h2>
              </div>
              <div className="col-12 col-lg-4">
                <img src="./static/assets/img/dashboard/Nursery.png" alt="" className = "Images ms-3 ms-lg-0"/>
              </div>
              <div className="col-12  pt-4 px-3">
                <p className="green" style={{ fontWeight: "600", marginBottom: "-7px" }}>Total number of nurseries</p>
              </div>
            </div>
          </div>
          </div>

          <div className="col-12 col-lg-3 mt-2 mt-lg-0">
          <div className="card pb-4 pt-3 a_card n_shadow">
            <div className="row px-2">
              <div className="col-12 col-lg-8">
                <h2 className='text-dark ps-4 pt-2'>346</h2>
              </div>
              <div className="col-12 col-lg-4">
                <img src="./static/assets/img/dashboard/Plantations.png" alt="" className = "Images ms-3 ms-lg-0" />
              </div>
              <div className="col-12  pt-4 px-3">
                <p className="green" style={{ fontWeight: "600", marginBottom: "-7px" }}>Total number of plants present in the nursery</p>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};
